/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accRenameForm', ['$rootScope', 'operationComplete',
        function ($rootScope, operationComplete) {
            return {
                scope: {
                    node: '='
                },
                restrict: 'E',
                template: '<form id="rename-form" ng-click="$event.stopPropagation()" ng-keydown="$event.stopPropagation()">\
                                <input type="text" id="rename-to" ng-model="renameTo" size="30" />\
                                <button class="btn btn-primary" ng-class="{ disabled: loading }" ng-click="save()">{{ \'Save\' | translate}}</button>\
                                <button class="btn" ng-class="{ disabled: loading }" ng-click="close()">{{ \'Cancel\' | translate }}</button>\
                           </form>',
                replace: true,
                controller: ['$scope', function ($scope) {
                    $scope.renameTo = $scope.node['name'];

                    $scope.save = function () {
                        if (changed()) {
                            $scope.loading = true;

                            $scope.node
                                .update({name: $scope.renameTo})
                                .then(function () {
                                    operationComplete($scope.node['is_directory'] ? "Folder renamed." : "File renamed.");
                                    $rootScope.$broadcast('reload.dataTable');
                                    $scope.close();
                                })
                                .finally(function () {
                                    $scope.loading = false;
                                });
                        } else {
                            $scope.close();
                        }
                    };

                    $scope.close = function () {
                        $scope.node['renaming'] = false;
                    };

                    function changed() {
                        return $scope.renameTo != $scope.node['name'];
                    }
                }],
                link: function ($scope, $element) {
                    focusInput();

                    function focusInput() {
                        $element.find('input').select();
                    }
                }
            }
        }]);
